<template>
  <div class="home">
    <Header @walletModal="walletModal" @loginTP="loginTP" />
    <main>
      <div class="main-container">
        <div class="banner">
          <img class="banner-pc" src="../assets/images/banner-pc.png" alt="" />
          <img
            class="banner-mobile"
            src="../assets/images/banner-mobile.png"
            alt=""
          />
        </div>
        <WalletConnectContent
          @walletModal="walletModal"
          ref="walletRef"
          @close="close"
        />
        <div class="activities-content">
          <div class="activities-left-list">
            <ActivityItem
              v-for="(item, index) in activityLeftList"
              :key="index"
              :activity="item"
            />
          </div>
          <div class="activities-left-list activities-right-list">
            <ActivityItem
              v-for="(item, index) in activityRightList"
              :key="index"
              :activity="item"
            />
          </div>
        </div>
        <a href="https://galxe.com/TokenPocket" class="more-button">
          <span>{{ $t('discoverMore') }}</span>
          <img src="../assets/images/arrow.png" alt="" />
        </a>
      </div>
    </main>
    <!-- <Footer /> -->
    <Modal v-if="isModal">
      <div class="connect-wallet-modal-content">
        <div class="title">{{ $t('modal.title') }}</div>
        <div class="desc">{{ $t('modal.desc') }}</div>
        <div class="tp-wallet-list">
          <div
            class="tp-wallet-item"
            :class="{ 'tp-wallet-item-qr-code': index === 1 }"
            v-for="(item, index) in walletModalList"
            :key="index"
          >
            <div class="left">
              <div class="logo-wrap">
                <img class="large" :src="item.largeIcon" alt="" />
                <img class="small" :src="item.smallIcon" alt="" />
              </div>
              <div class="wallet-label">
                <div class="label-1" v-if="item.label_1">
                  {{ item.label_1 }}
                </div>
                <div class="label-1 label-2" v-if="item.label_1">
                  {{ item.label_2 }}
                </div>
              </div>
            </div>
            <div class="right">
              <a :href="extensionUrl" class="add-button" v-if="item.add">{{
                $t('start')
              }}</a>
              <div class="qr-code" v-if="item.qrCode">
                <div class="qr-code-img"></div>
              </div>
            </div>
            <img
              class="qr-code-large"
              src="../assets/images/qr-code.png"
              alt=""
            />
          </div>
        </div>
        <div class="others-wallet">
          <div class="injected" @click="otherWalletConnect('MetaMask')">
            <span>{{ $t('modal.text_4') }}</span>
          </div>
        </div>
        <img
          class="close"
          src="../assets/images/close.png"
          @click="walletModal(false)"
          alt=""
        />
      </div>
    </Modal>
    <Modal v-if="isMobileModal">
      <div class="connect-wallet-step">
        <div class="title">{{ $t('connectWallet') }}</div>
        <WalletConnectContent ref="walletRef" @close="close" />
        <img
          class="close"
          src="../assets/images/close.png"
          @click="isMobileModal = false"
          alt=""
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Web3 from "web3";
import Modal from '@/components/Modal.vue';
import ActivityItem from '../components/ActivityItem.vue';
import ActivityMobileItem from '@/components/ActivityMobileItem.vue';
import Header from '../components/Header.vue';
import WalletConnectContent from '@/components/WalletConnectContent.vue';

export default {
  name: 'Home',
  components: {
    Header,
    WalletConnectContent,
    ActivityItem,
    // ActivityMobileItem,
    Modal,
  },
  data() {
    return {
      isModal: false,
      isMobileModal: false,
      balance: '',
      unsubscribe: {},
      step: 0,
      selectedChainId: '',
    };
  },
  computed: {
    ...mapGetters(['address']),
    extensionUrl() {
      let lang = 'en';
      if (this.$i18n.locale === 'zh') {
        lang = 'zh';
      }
      return `https://chromewebstore.google.com/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii?hl=${lang}`;
    },
    activityLeftList() {
      return [
        {
          activityId: 'GCMn8ttzs9',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCMn8ttzs9',
          activityIcon: require(`../assets/images/activity/TokenPocket-logo.png`),
          activityOTA: require(`../assets/images/activity/TokenPocket.png`),
          activityTitle: this.$t('activity_1_1'),
          activityText: this.$t('activity_1_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
          ],
        },
        {
          activityId: 'GChu6ttqVG',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GChu6ttqVG',
          tutorialUrl:
            'https://medium.com/@eddy_protocol/eddy-finance-tokenpocket-christmas-campaign-a3d196f435a5',
          activityIcon: require(`../assets/images/activity/eddy-logo.jpeg`),
          activityOTA: require(`../assets/images/activity/Eddy-Finance.png`),
          activityTitle: this.$t('activity_3_1'),
          activityText: this.$t('activity_3_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_3_5'),
              desc: this.$t('activity_3_6'),
            },
          ],
        },
        {
          activityId: 'GCnW8tthSy',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCnW8tthSy',
          tutorialUrl:
            'https://medium.com/@zkMe/spread-holiday-cheer-with-zkme-identity-oracles-your-christmas-lucky-sign-06c69eaa3fd3',
          activityIcon: require(`../assets/images/activity/zkMe-logo.jpeg`),
          activityOTA: require(`../assets/images/activity/zkMe.png`),
          activityTitle: this.$t('activity_5_1'),
          activityText: this.$t('activity_5_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_5_5'),
              desc: this.$t('activity_5_6'),
            },
          ],
        },
        {
          activityId: 'GCns8ttTLv',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCns8ttTLv',
          activityIcon: require(`../assets/images/activity/SushiSwap-logo.png`),
          activityOTA: require(`../assets/images/activity/SushiSwap.png`),
          activityTitle: this.$t('activity_7_1'),
          activityText: this.$t('activity_7_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
          ],
        },
        {
          activityId: 'GCgP6tt9zy',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCgP6tt9zy',
          tutorialUrl:
            'https://www.youtube.com/watch?v=bzQyj-AUtg0&feature=youtu.be',
          activityIcon: require(`../assets/images/activity/ChatGM-logo.png`),
          activityOTA: require(`../assets/images/activity/ChatGM.jpg`),
          activityTitle: this.$t('activity_9_1'),
          activityText: this.$t('activity_9_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_9_5'),
              desc: this.$t('activity_9_6'),
            },
            {
              name: this.$t('activity_9_7'),
              desc: this.$t('activity_9_8'),
            },
          ],
        },
      ];
    },
    activityRightList() {
      return [
        {
          activityId: 'GCTy6ttCqT',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCTy6ttCqT',
          tutorialUrl:
            'https://medium.com/@zetaswapdex/zetaswap-and-tokenpocket-christmas-campaign-tutorial-4da9812bc3cd',
          activityIcon: require(`../assets/images/activity/zetaswap-logo.jpg`),
          activityOTA: require(`../assets/images/activity/zetaswap.png`),
          activityTitle: this.$t('activity_2_1'),
          activityText: this.$t('activity_2_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_2_5'),
              desc: this.$t('activity_2_6'),
            },
          ],
        },
        {
          activityId: 'GChv6ttcJ5',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GChv6ttcJ5',
          tutorialUrl: 'https://lenx.gitbook.io/lenx/lenxlend/how-to-use-lenx',
          activityIcon: require(`../assets/images/activity/LENX-logo.png`),
          activityOTA: require(`../assets/images/activity/LENX.png`),
          activityTitle: this.$t('activity_4_1'),
          activityText: this.$t('activity_4_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_4_5'),
              desc: this.$t('activity_4_6'),
            },
            {
              name: this.$t('activity_4_7'),
              desc: this.$t('activity_4_8'),
            },
          ],
        },
        {
          activityId: 'GChG6ttcDb',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GChG6ttcDb',
          tutorialUrl:
            'https://ultiversedao.medium.com/tokenpocket-christmas-with-ultiverse-and-zetachain-meta-merge-match-three-tutorials-79a67fe45843',
          activityIcon: require(`../assets/images/activity/Ultiverse-logo.jpeg`),
          activityOTA: require(`../assets/images/activity/Ultiverse.png`),
          activityTitle: this.$t('activity_6_1'),
          activityText: this.$t('activity_6_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_6_5'),
              desc: this.$t('activity_6_6'),
            },
          ],
        },
        {
          activityId: 'GCTg6ttGem',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCTg6ttGem',
          tutorialUrl: 'https://youtu.be/cUw_vG59qZk',
          activityIcon: require(`../assets/images/activity/Suger-logo.png`),
          activityOTA: require(`../assets/images/activity/Suger.png`),
          activityTitle: this.$t('activity_8_1'),
          activityText: this.$t('activity_8_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_8_5'),
              desc: this.$t('activity_8_6'),
            },
          ],
        },
        {
          activityId: 'GCAe8ttX1T',
          activityUrl: 'https://galxe.com/TokenPocket/campaign/GCAe8ttX1T',
          activityIcon: require(`../assets/images/activity/CharacterX-logo.jpg`),
          activityOTA: require(`../assets/images/activity/CharacterX.png`),
          activityTitle: this.$t('activity_10_1'),
          activityText: this.$t('activity_10_2'),
          activityNameList: [
            {
              name: this.$t('activity_text_1'),
              desc: this.$t('activity_text_2'),
            },
            {
              name: this.$t('activity_10_5'),
              desc: this.$t('activity_10_6'),
            },
          ],
        },
      ];
    },
    walletModalList() {
      return [
        {
          largeIcon: require(`../assets/images/activity/TokenPocket-logo.png`),
          smallIcon: require(`../assets/images/Google.png`),
          label_1: this.$t('modal.text_1'),
          add: true,
        },
        {
          largeIcon: require(`../assets/images/activity/TokenPocket-logo.png`),
          smallIcon: require(`../assets/images/iPhone.png`),
          label_1: this.$t('modal.text_2'),
          label_2: this.$t('modal.text_3'),
          qrCode: true,
        },
      ];
    },
    othersWalletList() {
      return [
        {
          logo: require(`../assets/images/transit.png`),
          walletType: 'MetaMask',
        },
        {
          logo: require(`../assets/images/transit.png`),
          walletType: 'WalletConnect',
        },
      ];
    },
  },

  mounted() {
    if (navigator.userAgent.indexOf('TokenPocket') > -1) {
      // this.initETH();
    } else {
      // this.walletSubscribe();
    }
  },
  methods: {
    loginTP() {
      console.log('loginTP');
      this.isMobileModal = true;
    },
    async otherWalletConnect(walletType) {
      if (walletType === 'MetaMask' && this.$refs.walletRef) {
        // console.log(
        //   'this.$refs',
        //   this.$refs.walletRef.connectWalletByMetaMask()
        // );
        this.$refs.walletRef.connectWalletByMetaMask();
      }
    },
    async connectWalletByMetaMask() {
      if (window.ethereum) {
        console.log('connectWalletByMetaMask', window.ethereum);
        try {
          let account = await window.ethereum.request({
            method: 'eth_requestAccounts',
          });
          this.$store.commit('setAddress', account[0]);
          this.isModal = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    walletModal(flag) {
      this.isModal = flag;
    },
    async switchToZetaChainTestnet() {
      return new Promise((resolve, reject) => {
        window.ethereum
          .request({
            method: 'wallet_switchEthereumChain',
            params: [
              {
                chainId: '0x1b59',
              },
            ],
          })
          .then(resolve)
          .catch(reject);
      });
    },
    close() {
      this.isModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding-bottom: 1.83rem;
  .connect-wallet-modal-content {
    background: #ffffff;
    border: 0.01rem solid #e3e3e3;
    border-radius: 0.24rem;
    box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
    padding: 0.24rem;
    .title {
      font-size: 0.22rem;
      font-family: Poppins-Semibold;
      color: #2a2a2a;
      text-align: center;
    }
    .desc {
      margin-top: 0.1rem;
      font-size: 0.13rem;
      font-family: Poppins-Regular;
      color: #2a2a2a;
      text-align: center;
    }
    .tp-wallet-list {
      margin-top: 0.16rem;
      .tp-wallet-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f5f5f5;
        border: 0.01rem solid #e3e3e3;
        border-radius: 0.16rem;
        padding: 0.12rem;
        box-sizing: border-box;
        cursor: pointer;
        &:nth-child(n + 2) {
          margin-top: 0.08rem;
        }
        .left {
          display: flex;
          align-items: center;
          .logo-wrap {
            position: relative;
            display: flex;
            img {
              border-radius: 50%;
            }
            .large {
              width: 0.32rem;
              height: 0.32rem;
            }
            .small {
              position: absolute;
              right: -0.04rem;
              bottom: 0;
              width: 0.18rem;
              height: 0.18rem;
              border: 0.02rem solid #fff;
            }
          }
          .wallet-label {
            margin-left: 0.12rem;
            .label-1 {
              font-size: 0.14rem;
              font-family: Poppins-Medium;
              color: #2a2a2a;
              text-align: left;
            }
            .label-2 {
              font-size: 0.12rem;
              font-family: Poppins-Regular;
              text-align: left;
              color: rgba(42, 42, 42, 0.6);
              transform: scale(0.92);
              margin-left: -0.1rem;
              text-align: left;
            }
          }
        }
        .right {
          margin-left: 0.3rem;
          display: flex;
          .add-button {
            padding: 0.06rem 0.2rem;
            background: #2980fe;
            border-radius: 0.18rem;
            font-size: 0.12rem;
            font-family: Poppins-Medium;
            color: #ffffff;
            transform: scale(0.92);
            margin-left: -0.1rem;
          }
          .qr-code {
            display: flex;
            .qr-code-img {
              width: 0.28rem;
              height: 0.28rem;
              background: url('../assets/images/qr-code-s.png') no-repeat center
                center;
              background-size: 100% 100%;
            }
          }
        }
        .qr-code-large {
          display: none;
          width: 1.36rem;
          height: 1.62rem;
          position: absolute;
          right: -1.7rem;
          top: -0.5rem;
        }
      }
      .tp-wallet-item:hover {
        background: #deebff;
        border: 0.01rem solid #2980fe;
        .right {
          .qr-code {
            .qr-code-img {
              background: url('../assets/images/qr-code-s-on.png') no-repeat
                center center;
              background-size: 100% 100%;
            }
          }
        }
      }
      .tp-wallet-item-qr-code:hover {
        background: #deebff;
        border: 0.01rem solid #2980fe;
        .right {
          .qr-code {
            .qr-code-img {
              background: url('../assets/images/qr-code-s-on.png') no-repeat
                center center;
              background-size: 100% 100%;
            }
          }
        }
        .qr-code-large {
          display: block;
        }
      }
    }
    .others-wallet {
      margin-top: 0.24rem;
      .injected {
        display: flex;
        justify-content: center;
        span {
          font-size: 0.13rem;
          font-family: Poppins-Medium;
          text-align: center;
          color: #2a2a2a;
          cursor: pointer;
        }
      }
    }
    .close {
      position: absolute;
      right: 0.16rem;
      top: 0.16rem;
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
  }
  main {
    .main-container {
      max-width: 12rem;
      margin: 0 auto;
      .banner {
        font-size: 0;
        .banner-pc {
          width: 100%;
          border-radius: 0.24rem;
        }
        .banner-mobile {
          display: none;
        }
      }
      .wallet-connect-content {
        display: flex;
        justify-content: space-between;
        margin: 0.35rem 0.45rem 0;
        .wallet-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 0.35rem;
          box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
          padding: 0.09rem 0.1rem;
          border: 0.01rem solid #e3e3e3;
          background: #f5f5f5;
          cursor: pointer;
          &.active-item {
            background: rgba(255, 255, 255, 0.71);
            .wallet-left {
              .wallet-info {
                color: #2a2a2a;
              }
            }
          }
          &.circle-item {
            background: none;
            border: none;
            box-shadow: none;
          }
          .circle-list {
            display: flex;
            .circle {
              width: 0.04rem;
              height: 0.04rem;
              background: #e6e6e6;
              border-radius: 50%;
              &:nth-child(n + 2) {
                margin-left: 0.03rem;
              }
            }
          }
          .wallet-left {
            display: flex;
            align-items: center;
            .wallet-logo {
              display: flex;
              align-items: center;
              img {
                width: 0.48rem;
                height: 0.48rem;
                border-radius: 50%;
              }
            }
            .wallet-info {
              margin-left: 0.12rem;
              font-size: 0.16rem;
              font-family: PingFang SC, PingFang SC-Semibold;
              color: #c9c9c9;
            }
          }
          .wallet-right {
            margin-left: 0.04rem;
            display: flex;
            align-items: center;
            img {
              width: 0.18rem;
              height: 0.18rem;
            }
          }
        }
      }
      .activities-content {
        margin-top: 0.36rem;
        display: flex;
        .activities-left-list {
          flex: 1;
        }
        .activities-right-list {
          flex: 1;
          margin-left: 0.2rem;
        }
      }
      .more-button {
        width: fit-content;
        margin: 0.6rem auto 0;
        background: #2980fe;
        border-radius: 0.35rem;
        box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        padding: 0.18rem 0.34rem 0.18rem 1.36rem;
        cursor: pointer;
        span {
          font-size: 0.22rem;
          font-family: Poppins-Semibold;
          color: #ffffff;
        }
        img {
          margin-left: 0.55rem;
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .home {
    padding: 0 0.2rem 1.83rem;
  }
}
@media screen and (max-width: 767px) {
  .home {
    padding: 0;
    .connect-wallet-step {
      position: relative;
      background: #ffffff;
      border: 0.01rem solid #e3e3e3;
      border-radius: 0.32rem;
      box-shadow: 0 0.06rem 0.3rem 0 rgba(0, 0, 0, 0.1);
      margin: 0 0.32rem;
      padding: 0.4rem 0;
      .title {
        font-size: 0.34rem;
        font-family: Poppins-Semibold;
        text-align: center;
        color: #2a2a2a;
      }
      .wallet-connect-content {
        margin-top: 0.32rem;
      }
      .close {
        position: absolute;
        right: 0.28rem;
        top: 0.28rem;
        width: 0.24rem;
        height: 0.24rem;
        cursor: pointer;
      }
    }
    main {
      margin-bottom: 1rem;
      padding: 0 0.32rem;
      .main-container {
        max-width: none;
        .banner {
          .banner-pc {
            display: none;
          }
          .banner-mobile {
            display: block;
            width: 100%;
            border-radius: 0.24rem;
          }
        }
        .wallet-connect-content {
          display: none;
        }
        .activities-content {
          margin-top: 0.32rem;
          flex-direction: column;
          // .activities-left-list {
          // }
          .activities-right-list {
            margin-left: 0;
          }
        }
        .more-button {
          width: 100%;
          padding: 0.26rem 0.6rem;
          justify-content: center;
          padding: 0.26rem 0;
          border-radius: 0.6rem;
          span {
            font-size: 0.26rem;
          }
          img {
            margin-left: 0.06rem;
            width: 0.26rem;
            height: 0.26rem;
          }
        }
      }
    }
  }
}
</style>
